const steps = document.querySelectorAll(".step");
const timeline = document.querySelector(".timeline");
const line = document.querySelector(".line");
let prevScrollY = window.scrollY;
let downDirection;
let full = false;
let set = 0;
const targetY = window.innerHeight;

Fancybox.bind('[data-fancybox="gallery"]', {});

function scrollHandler(e) {
  const { scrollY } = window;
  downDirection = scrollY < prevScrollY;
  const timelineRect = timeline.getBoundingClientRect();
  const lineRect = line.getBoundingClientRect();
  const remToPx = parseInt(getComputedStyle(document.documentElement).fontSize);

  // distance from top of timeline to bottom of window
  const dist = targetY - timelineRect.top;
  const lineDist = dist - 7 * remToPx;

  if (!downDirection && !full) {
    set = Math.max(set, lineDist);
    line.style.bottom = `calc(100% - ${set}px)`;
  }

  if (lineDist > timeline.offsetHeight - 7 * remToPx && !full) {
    line.style.bottom = "7rem";
    full = true;
  }

  // Calculate position of each timeline image, transition between 
  const getFullWidth = (elem) => {
    if (!elem) return 0;
    const style = elem.currentStyle || window.getComputedStyle(elem),
      width = elem.offsetWidth, // or use style.width
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    return width + margin - padding + border;
  }

  let activeItem;
  const firstItem = steps[0];
  const firstItemBounding = firstItem.getBoundingClientRect();
  const firstImg = firstItem.querySelector(".media-content");
  // const firstImgBounding = firstImg.getBoundingClientRect();

  steps.forEach((item, index) => {
    const imgElem = item.querySelector(".media-content");
    imgElem.style.opacity = 0;
    item.classList.remove("show-me");
  })

  steps.forEach((item, index) => {
    const rect = item.getBoundingClientRect();

    if (rect.top < window.innerHeight / 2) {
      activeItem = item;
    }
  });

  if (activeItem) {
    const imgElem = activeItem.querySelector(".media-content");
    const imgElemBounding = imgElem.getBoundingClientRect();
    const yearWidth = getFullWidth(activeItem.querySelector("p")) + 30;
    if (imgElem) {
      imgElem.style.right = "calc(50% + " + yearWidth + "px";
      imgElem.style.opacity = 1;
      imgElem.style.transform = "translateY(-50%)";
      imgElem.style.top = "50%";
      activeItem.classList.add("show-me");
    }
    if (imgElemBounding.bottom > timelineRect.bottom + 150) {
      imgElem.style.opacity = 0;
      activeItem.classList.remove("show-me");
    }
  }

  if (window.scrollY <= firstItemBounding.top) {
    firstItem.classList.remove("show-me");
    firstImg.style.position = "static";
    firstImg.style.opacity = 1;
    firstImg.style.transform = "none";
    // firstImg.style.maxWidth = "100%";
  }
  else {
    firstImg.style.position = "fixed";
    // firstImg.style.opacity = 1;
    // firstImg.style.transform = "none";
  }

  prevScrollY = window.scrollY;
}

scrollHandler();
window.addEventListener("scroll", scrollHandler);
